import ReservationReportIndex from "@/views/report/reservation/ReservationReportIndex.vue";
const reservationReport = [
  {
    path: "/reservation-report",
    name: "reservation-report",
    component: ReservationReportIndex,
    meta: {
      layout: "default",
      role: ["superadmin"],
      public: false,
    },
  },
];

export default reservationReport;
